module.exports = __webpack_public_path__ + "img/icon_map_11_on_001.a34f0cf3.png";